import { Controller } from '@hotwired/stimulus';
import { Map } from '../../components/modern/maps/map';

const MAP_URL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=';

// Connects to data-controller="maps--map"
export default class extends Controller {
  static values = {
    locations: Array,
    googleKey: String,
    localVendorOrientation: String
  }

  connect() {
    if (document.googleMapLib) {
      this.initializeMap();
    } else {
      this.loadGoogleMaps();
    }
  }

  loadGoogleMaps() {
    const script = document.createElement('script');
    script.src = `${MAP_URL}${this.googleKeyValue}&libraries=places`;
    script.async = true;
    script.onload = () => {
      document.googleMapLib = true;
      this.initializeMap();
    };
    document.head.appendChild(script);
  }

  initializeMap() {
    new Map(this.element, this.locationsValue, this.localVendorOrientationValue);
  }
}
